import { ModalSuccess } from "assets/icons";
import Button from "components/BaseWidgets/button";
import Modal from "components/BaseWidgets/modal";
import "./style.scss";
const SuccessModal = ({ open, onCancel, onOk, title, description }) => {
  return (
    <Modal
      isOpen={open}
      className="success-modal-wrapper"
      onCancel={onCancel}
      width={464}
      closable
    >
      <div className="modal-content">
        <ModalSuccess />
        <h2 className="font-title-xl text-center">{title}</h2>
        {description && <p className="modal-description mt-3">{description}</p>}
        <Button className="modal-btn mt-8" onClick={onOk}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessModal;
